import dayjs from '../misc/dayjs'
import type { DrugEvent, RawDrugEvent } from '../types/health-data'
import { DrugEventPrestationType, DrugEventPrestationTypeLabel } from '../types/health-data'

export function getDrugEventPrestationTypes(drugEvents: DrugEvent[]): DrugEventPrestationType[] {
  return Array.from(new Set(drugEvents.map((item) => item.prestationType))).sort((a, b) => Number(b) - Number(a))
}

export function getDrugEventPrestationTypeLabel(type: DrugEventPrestationType) {
  return (
    DrugEventPrestationTypeLabel[
      Object.keys(DrugEventPrestationType)[Object.values(DrugEventPrestationType).indexOf(type)]
    ] || DrugEventPrestationTypeLabel.NONE
  )
}

export function formatDrugEvent(rawEvent: RawDrugEvent): DrugEvent {
  return {
    id: rawEvent.id,
    amount: rawEvent.amount,
    creationDate: dayjs(rawEvent.creationDate),
    drug: rawEvent.drug,
    indication: rawEvent.indication,
    prescriptionValidation: rawEvent.prescriptionValidation,
    prestationType: rawEvent.prestationType,
    type: rawEvent.type,
    unit: rawEvent.unit,
  }
}
